import { Injectable, inject } from '@angular/core';
import { HttpService } from './http.service';
import { Observable, catchError, map, throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { ErufunctionConfig } from '../models/erufunctions.model';
import { LoginResponse } from '../models/user.model';
import { Group } from '../models/erufunctions.model';
import { tap } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class ErufunctionService {
  private router = inject(Router);

  constructor(private httpService: HttpService) { }

  fetchConfig(url: string, project_name: string): Observable<{ project: ErufunctionConfig }> {
    
    return this.httpService.get<any>(
      `${url}/store/${project_name}/config`
    ).pipe(
      map(response => {
        if (response && response.project) {
          return { project: response.project };
        } else {
          return { project: {} };
        }
      }),
      catchError((error: HttpErrorResponse) => {
        console.error('API Error:', error);
        return throwError(() => new Error(error.error?.error || 'Projects not found'));
      })
    );
  }

  
  saveFunction(url:string,project_name:string,functionData:Group):Observable<any>{
    return this.httpService.post<any>(
      `${url}/store/${project_name}/func/save`,
      functionData
    ).pipe(
      tap((response:any)=>console.log('Function saved successfully: ',response)),
      catchError((error:HttpErrorResponse)=>{
        console.error('API Error');
        return throwError(()=> new Error(error.error?.error||'Failed to save Auth'));
      })
    );
  }

  removeFunction(url: string, project_name: string, funcName: string): Observable<any> {
    return this.httpService.delete<any>(
      `${url}/store/${project_name}/func/remove/${encodeURIComponent(funcName)}`
    ).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('API Error:', error);
        return throwError(() => new Error(error.error?.error || 'Failed to remove function'));
      })
    );
  }

  // Runs an unsaved func group starting at stepName; the backend answers {body, req_vars, res_vars}.
  runFunctionStep(url: string, project_name: string, stepName: string, funcGroup: Group,
    vars: { body?: any; req_vars?: any; res_vars?: any } = {}): Observable<{ body: any; req_vars: any; res_vars: any }> {
    return this.httpService.post<any>(
      `${url}/store/${project_name}/func/run/${encodeURIComponent(stepName)}`,
      { func: funcGroup, body: { body: vars.body ?? {}, req_vars: vars.req_vars ?? {}, res_vars: vars.res_vars ?? {} } }
    ).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('API Error:', error);
        return throwError(() => new Error(error.error?.error || 'Failed to run function'));
      })
    );
  }

  // Catalogue lists proxied by eru-functions to eru-ql / eru-ai.
  fetchMyQueryNames(url: string, project_name: string): Observable<{ query_name: string; query_type: string; source: string }[]> {
    return this.httpService.get<any>(`${url}/store/${project_name}/myquery/list`)
      .pipe(map(res => Array.isArray(res?.myqueries) ? res.myqueries : []));
  }

  fetchToolNames(url: string, project_name: string): Observable<string[]> {
    return this.httpService.get<any>(`${url}/store/${project_name}/tool/list`)
      .pipe(map(res => Array.isArray(res?.tools) ? res.tools : []));
  }

  fetchAgentNames(url: string, project_name: string): Observable<string[]> {
    return this.httpService.get<any>(`${url}/store/${project_name}/agent/list`)
      .pipe(map(res => Array.isArray(res?.agents) ? res.agents : []));
  }

  loginWithUserPassword(url: string, username: string, password: string): Observable<LoginResponse> {
    return this.httpService.post<LoginResponse>(url, { username, password }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('API Error:', error);
        return throwError(() => new Error(error.error?.error || 'Login failed'));
      })
    );
  }
}